import { COMMON_PERMISSIONS } from '@/commons/permissoesGrupos';

export default [
    // Detalhe do pagamento com o ordenador
    {
        path: '/pagamento/:id/ordenador',
        name: 'detalhePagamentoOrdenador',
        component: () => import('@/modules/ordenador/views/detalhes/DetalhePagamentoOrdenadorView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.EQUIPE_GESTAO_ORDENADOR,
        },
        props: true
    },

    // Lista de Autorizações
    {
        path: '/autorizacoes',
        name: 'listaAutorizacoes',
        component: () => import('@/modules/ordenador/views/listas/ListaOrdenadorView.vue'),
        meta: {
            requiresAuth: true,
            temFilhas: true,
            allowedRoles: COMMON_PERMISSIONS.EQUIPE_GESTAO_ORDENADOR,
        },
        redirect: { name: 'ordenadorPagamentos' },
        children: [
            {
                path: '/ordenacoes/pagamentos',
                name: 'ordenadorPagamentos',
                component: () => import('@/modules/ordenador/components/tab/PagamentoTab.vue'),
                meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.EQUIPE_GESTAO_ORDENADOR },
            },
            {
                path: '/ordenacoes/contratacoes',
                name: 'ordenadorContratacoes',
                component: () => import('@/modules/ordenador/components/tab/ContratacaoTab.vue'),
                meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.EQUIPE_GESTAO_ORDENADOR },
            },
            {
                path: '/ordenacoes/solicitacoespagamentobeneficioclt',
                name: 'ordenadorSolicitacoesPagamentoBeneficioCLT',
                component: () => import('@/modules/ordenador/components/tab/SolicitacoesPagamentoBeneficioCLTTab.vue'),
                meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.EQUIPE_GESTAO_ORDENADOR },
            },
            {
                path: '/ordenacoes/solicitacoespagamentofolhaclt',
                name: 'ordenadorSolicitacoesPagamentoFolhaCLT',
                component: () => import('@/modules/ordenador/components/tab/SolicitacoesPagamentoFolhaCLTTab.vue'),
                meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.EQUIPE_GESTAO_ORDENADOR },
            },
            {
                path: '/ordenacoes/solicitacoespagamentorescisaoclt',
                name: 'ordenadorSolicitacoesPagamentoRescisaoCLT',
                component: () => import('@/modules/ordenador/components/tab/SolicitacoesPagamentoRescisaoCLTTab.vue'),
                meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.EQUIPE_GESTAO_ORDENADOR },
            },
            {
                path: '/ordenacoes/solicitacoesadministrativas',
                name: 'ordenadorSolicitacoesAdministrativas',
                component: () => import('@/modules/ordenador/components/tab/SolicitacoesAdministrativasTab.vue'),
                meta: { requiresAuth: true, allowedRoles: COMMON_PERMISSIONS.EQUIPE_GESTAO_ORDENADOR },
            },
        ]
    },
]